import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CampaignForm from '../components/CampaignForm';

const API_BASE = process.env.REACT_APP_API_BASE || '';

function CampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [status, setStatus] = useState('');

  const fetchCampaigns = async () => {
    const res = await fetch(`${API_BASE}/backend/campaigns_list.php`);
    const data = await res.json();
    if (data.ok) setCampaigns(data.campaigns);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const handleDeleteCampaign = async (id) => {
    if (!window.confirm('Delete this campaign and its leads?')) return;
    const form = new FormData();
    form.append('id', id);

    const res = await fetch(`${API_BASE}/backend/campaign_delete.php`, {
      method: 'POST',
      body: form,
    });
    const data = await res.json();
    if (data.ok) {
      setStatus('Campaign deleted.');
      await fetchCampaigns();
    } else {
      setStatus(data.error || 'Failed to delete campaign.');
    }
  };

  return (
    <div className="grid">
      <CampaignForm onCreated={fetchCampaigns} />

      <section className="card">
        <h2>Campaigns</h2>
        {status && <div className="status">{status}</div>}
        <div className="campaigns">
          {campaigns.length === 0 && <div className="muted">No campaigns yet.</div>}
          {campaigns.map((c) => (
            <div key={c.id} className="campaign">
              <div>
                <div className="campaign-title">{c.name}</div>
                <div className="muted">Created {c.created_at}</div>
              </div>
              <div className="campaign-actions">
                <Link className="button" to={`/campaigns/${c.id}`}>Open</Link>
                <button className="danger" onClick={() => handleDeleteCampaign(c.id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default CampaignsPage;
